import httpClient from './httpClient';
import { getTenantConfig } from '../../config/tenantConfig';

const getBaseUrl = () => {
  const config = getTenantConfig();
  return config.api.witnessStatement;
};

export const schemaParserService = {
  async listSchemas() {
    const response = await httpClient.get(`${getBaseUrl()}/admin/schemas`);
    return response; // httpClient already unwraps response.data
  },

  async generateTags(schemaName) {
    const response = await httpClient.post(`${getBaseUrl()}/admin/schemas/${schemaName}/generate`);
    return response; // httpClient already unwraps response.data
  },

  async generateAllTags() {
    const response = await httpClient.post(`${getBaseUrl()}/admin/schemas/generate-all`);
    return response; // httpClient already unwraps response.data
  }
};
